import { ChangeEvent, useState } from "react";
import ISerial from "../../../models/ISerial";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import IOrderEntryProcessSerialDTO from "../../../models/DTO/IOrderEntryProcessSerialDTO";
import { OwDeleteEditActions } from "@components/shared/OwDeleteEditActions/OwDeleteEditActions";
import { OwAcceptCancelActions } from "@components/shared/OwAcceptCancelActions/OwAcceptCancelActions";
import IProcessSerialDTO from "@models/DTO/IProcessSerialDTO";
import { useAppContextNonNull } from "@contexts/AppContext";
import OwButton from "@components/shared/OwButton/OwButton";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwTitle from "@components/shared/OwTitle/OwTitle";

type Props = {
    row: IOrder_ItemUI;
    serial: ISerial;
    saveFn: (data: IProcessSerialDTO) => void;
    readOnly: boolean;
};

export const OrderEntryEditSerial = (props: Props) => {
    const { userModel, supplierModel, uiContext } = useAppContextNonNull();

    const [serial, setSerial] = useState(props.serial);
    const [editMode, setEditMode] = useState(false);
    const [preEditModeSerial, setPreEditModeSerial] = useState(props.serial);

    const closeModal = () => {
        uiContext.setModalComponent(null);
        uiContext.showModal(false);
    };

    const deleteSerial = (option: "unassign" | "delete") => {
        const payload: IProcessSerialDTO = {
            serialId: serial.id,
            serial: serial.value,
            userToken: userModel.token,
            userGuid: userModel.guid,
            supplierGuid: supplierModel.guid,
            orderItemGuid: props.row.guid,
            unassignFlag: option === "unassign",
            deleteFlag: option === "delete",
        };

        props.saveFn(payload);
    };

    const showDeleteModal = () => {
        uiContext.setModalComponent(
            <div className="p-3">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <OwTitle title={"serial_action"} tag={"h3"} />
                    <div>
                        <OwButton centerIconClass={"fas fa-times"} className={"btn-danger"} fn={closeModal} />
                    </div>
                </div>
                <div className="mb-4">
                    <OwLabel title={"delete_or_unassign_serial"} />
                </div>
                <div className="d-flex justify-content-center gap-2">
                    <OwButton
                        title={"delete"}
                        className={"btn-danger"}
                        fn={() => {
                            deleteSerial("delete");
                            closeModal();
                        }}
                    />
                    <OwButton
                        title={"unassign"}
                        className={"btn-secondary"}
                        fn={() => {
                            deleteSerial("unassign");
                            closeModal();
                        }}
                    />
                </div>
            </div>
        );
        uiContext.showModal(true);
    };

    const editSerial = () => {
        setEditMode(!editMode);
        setPreEditModeSerial(serial);
    };

    const handleRowSerial = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        const _serial = {
            ...serial,
            value,
        };

        setSerial(_serial);
    };

    const saveSerial = () => {
        const payload: IOrderEntryProcessSerialDTO = {
            serialId: serial.id,
            serial: serial.value,
            userToken: userModel.token,
            userGuid: userModel.guid,
            supplierGuid: supplierModel.guid,
            orderItemGuid: props.row.guid,
        };

        props.saveFn(payload);
    };

    const cancelSave = () => {
        setSerial(preEditModeSerial);
        setEditMode(false);
    };

    return (
        <div className={"OrderEntryEditSerial mb-2"}>
            <div className={"d-flex align-items-center"}>
                {editMode || props.readOnly ? null : (
                    <OwDeleteEditActions
                        className="me-2"
                        isEditMode={editMode}
                        onTrashClickFn={showDeleteModal}
                        onEditClickFn={editSerial}
                    />
                    // <span>
                    //     <OwIconButton iconClass={"fa fa-trash-alt"} iconColorClass={"text-danger me-2"} fn={deleteSerial} />
                    //     <OwIconButton iconClass={"fa fa-pencil-alt"} iconColorClass={"text-primary me-2"} fn={editSerial} />
                    // </span>
                )}
                {editMode ? (
                    <div className={"d-flex"}>
                        <div>
                            <OwAcceptCancelActions
                                isEditMode={!editMode}
                                onAcceptClickFn={saveSerial}
                                onCancelClickFn={cancelSave}
                                withLabels={false}
                                className={"me-2"}
                            />
                        </div>
                        <div className={"w-15r"}>
                            <OwFnInput value={serial.value} fn={handleRowSerial} name={"serial"} />
                        </div>
                    </div>
                ) : (
                    serial.value
                )}
            </div>
        </div>
    );
};
